import React, { useState, cloneElement, isValidElement } from "react";
import styles from "../../styles/pages/games/GameHub.module.scss";
import GameCard from "./GameCard";
import Modal from "./Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBolt, faBrain, faWindowRestore } from "@fortawesome/free-solid-svg-icons";


// Games
import NeonDash from "./NeonDash";
import QuickMath from "./QuickMath";
import TypeSprint from "./TypeSprint";
import NeonMemory from "./NeonMemory";
import GeoRecall from "./GeoRecall";
import LawGame from "./LawGame";
// import BudgetBalancer from "./BudgetBalancer";
import USHistoryQuiz from "./USHistoryQuiz";
import GeoCapitals from "./GeoCapitals";
// import PassportRun from "./GeoCapitals";

const GAMES = [
  {
    id: "mic-flap",
    title: "Mic Flap",
    tag: "Arcade • Reflex",
    desc: "Jump, dash, collect. A flashy endless runner.",
    component: <NeonDash />,
  },
  {
    id: "quick-math",
    title: "Quick Math",
    tag: "Exercise • Math",
    desc: "Answer as many equations as you can before time runs out.",
    component: <QuickMath />,
  },
  {
    id: "type-sprint", // NEW
    title: "Type Sprint",
    tag: "WPM • Typing",
    desc: "Train speed and accuracy. 60-second neon typing test.",
    component: <TypeSprint seconds={60} />, // popup content
  },
  {
    id: "match-grid", // NEW
    title: "Match Grid",
    tag: "Focus • Memory",
    desc: "Flip and match pairs. Train working memory and focus.",
    component: <NeonMemory size="4x4" />, // plays in the modal
  },
  {
  id: "geo-recall",
  title: "World Continent",
  tag: "Education • Geography",
  desc: "Learn World Geography. Mental exercise flight with score, best, and hints.",
  component: <GeoRecall />, // opens in modal
},
{
  id: "legal-law",
  title: "Law Game",
  tag: "Education • Law",
  desc: "Pick a category and take a quick quiz with explanations.",
  component: <LawGame />, // modal play
},

  {
    id: "us-history-quiz",
    title: "U.S. History Quiz",
    tag: "Education • History",
    desc: "10 randomized questions on key American political history.",
    component: <USHistoryQuiz />, // opens in your modal
  },

  {
    id: "geo-capitals",
    title: "Geo Capitals",
    tag: "Education • Geography",
    desc: "Guess world capitals from flags. Regions, lifelines, and postcard vibe.",
    component: <GeoCapitals />, // open in your modal
  },

  // Add more later: Typing Trainer, Memory Match, Logic Grid, Vocabulary Duel...

];

export default function GameHub() {
  const [openGame, setOpenGame] = useState(null);

  return (
    <div className={styles.page}>
      {/* Hero / Banner */}
      <section className={styles.hero}>
        <div className={styles.heroInner}>
          <h1 className={styles.title}>Playground</h1>
          <p className={styles.subtitle}>
          A collection of interactive mini games built to train and exercise the brain.          </p>
          {/* <div className={styles.heroStats}>
            <div className={styles.stat}><span>⚡</span> Instant play</div>
            <div className={styles.stat}><span>🧠</span> Learn by doing</div>
            <div className={styles.stat}><span>🖼️</span> No redirects</div>
          </div> */}
          <div className={styles.heroStats}>
  <div className={styles.stat}>
    <FontAwesomeIcon icon={faBolt} className={styles.statIcon} />
    <span>Instant play</span>
  </div>

  <div className={styles.stat}>
    <FontAwesomeIcon icon={faBrain} className={styles.statIcon} />
    <span>Learn by doing</span>
  </div>

  <div className={styles.stat}>
    <FontAwesomeIcon icon={faWindowRestore} className={styles.statIcon} />
    <span>No redirects</span>
  </div>
</div>
        </div>
        <div className={styles.heroGlow} aria-hidden />
      </section>

      {/* Cards */}
      <section className={styles.gridWrap}>
        <div className={styles.grid}>
          {GAMES.map(g => (
            <GameCard
              key={g.id}
              title={g.title}
              tag={g.tag}
              desc={g.desc}
              onPlay={() => setOpenGame(g)}
            />
          ))}
        </div>
      </section>

      {/* Modal */}
      <Modal
        open={!!openGame}
        title={openGame?.title || ""}
        onClose={() => setOpenGame(null)}
      >
        {isValidElement(openGame?.component)
    ? cloneElement(openGame.component, { onExit: () => setOpenGame(null) })
    : openGame?.component}
      </Modal>
    </div>
  );
}
